import ReadAndSelect from "./ReadAndSelect";
import Tabs from "../../../../components/Tabs/Tabs";
import QuestionTabs from "../variables/QuestionTabs";
import {useEffect, useState} from "react";
import CommentInputBox from "../../../../components/CommentBox/CommentInputBox";
import Comment from "../../../../components/CommentBox/Comment";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import QuestionRoutes from "./QuestionRoutes";
import CommentSection from "../component/CommentSection";
import NoteBookSection from "../component/NoteBookSection";
import MyPracticeSection from "../component/MyPracticeSection";
import CategorySelection from "../component/CategorySelection";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import PracticeAnalysisQuestions from "../../../../utils/pratice-analysis-quesstions";


export default function QuestionPagesIndex({className, ...props}) {
    const [activeTab, setActiveTab] = useState(QuestionTabs[0].key)
    const location = useLocation();
    const QuestionId = location.pathname.split("/").pop();
    const {question, questionActions} = useQuestion()
    const [tabs, setTabs] = useState(QuestionTabs)

    useEffect(() => {
        if (PracticeAnalysisQuestions.includes(question?.category?.type) )
            setTabs((QuestionTabs))
        else
            setTabs(QuestionTabs.filter((tab) => tab.key !== "practice"))

    }, [question])
    return (
        <div className={`max-w-full pt-12 lg:max-w-full m-auto flex-col flex gap-8  px-4  ${className}`}>
            <div

                className={"overflow-visible mt-5 lg:mt-0 justify-center items-center flex flex-row gap-8 px-10"}>
                <CategorySelection/>
            </div>

            <div className={"w-full max-w-full 2xl:w-[1500px] 2xl:mx-auto"}>
                <Routes>
                    {
                        QuestionRoutes.map((route, index) => {
                            return <Route key={index} path={route.path} element={<route.Component className={"bg-white"}/>}/>
                        })
                    }
                    <Route path={"*"} element={<Navigate to={"/practice"}/>}/>
                </Routes>
            </div>
            <div className={"flex flex-col gap-4 px-4 w-full 2xl:w-[1500px] 2xl:mx-auto"}>
                <Tabs tabs={tabs} defaultSelected={activeTab} onChange={setActiveTab}/>

                <CommentSection id={QuestionId} show={activeTab === "comments"}/>
                <NoteBookSection id={QuestionId} show={activeTab === "notebook"}/>
                {PracticeAnalysisQuestions.includes(question?.category?.type) &&
                    <MyPracticeSection id={QuestionId} show={activeTab === "practice"}/>}


            </div>
        </div>

    )
}
